import { useState } from 'react';
import Fade from '@mui/material/Fade';
import Zoom from '@mui/material/Zoom';
import { Flex } from '../../layout';
import { Emoji } from './Emoji';
import { EmojiSelector, ContentWrapper, RatingText } from './styledComponents';
var MAP_RATING_TO_EMOJI = {
    1: '😤',
    2: '☹️',
    3: '😐',
    4: '🙂',
    5: '🤩',
};
var MAP_RATING_TO_TEXT = {
    1: "I really don't like it",
    2: "I don't like it",
    3: "It's fine",
    4: 'I like it',
    5: 'I love it!',
};
export var RatingSelector = function (_a) {
    var _b = _a.selectedRating, selectedRating = _b === void 0 ? null : _b, _c = _a.showInitialMessage, showInitialMessage = _c === void 0 ? true : _c, onSelect = _a.onSelect;
    var _d = useState(false), selectorOpen = _d[0], setSelectorOpen = _d[1];
    var _e = useState(null), text = _e[0], setText = _e[1];
    var selectedSymbol = selectedRating && MAP_RATING_TO_EMOJI[selectedRating];
    var renderEmoji = function (rating) {
        var text = MAP_RATING_TO_TEXT[rating];
        var symbol = rating
            ? MAP_RATING_TO_EMOJI[rating]
            : selectedRating
                ? MAP_RATING_TO_EMOJI[selectedRating]
                : null;
        return (symbol && (<Emoji data-testid={"emoji-".concat(rating)} symbol={symbol} label={text} onMouseEnter={function () { return setText(text); }} onClick={function () {
                setText('');
                onSelect(rating);
            }}/>));
    };
    var renderSelector = function () {
        var showSelector = selectorOpen || !showInitialMessage;
        return (<>
        {showSelector ? (<Zoom data-testid="emoji-selector" in={showSelector} timeout={250} unmountOnExit>
            <EmojiSelector multi>
              {renderEmoji(1)}
              {renderEmoji(2)}
              {renderEmoji(3)}
              {renderEmoji(4)}
              {renderEmoji(5)}
            </EmojiSelector>
          </Zoom>) : null}
        {!showSelector ? (<Zoom data-testid="feedback-label" in={!showSelector} timeout={250} unmountOnExit>
            <ContentWrapper padded>
              We <Emoji symbol={'💕'} label="Love"/> Feedback
            </ContentWrapper>
          </Zoom>) : null}
      </>);
    };
    return (<Flex alignment="center">
      <Fade in={text !== ''} timeout={300}>
        <RatingText>{text}</RatingText>
      </Fade>
      <div data-testid="rating-selector" onMouseEnter={function () { return setSelectorOpen(true); }} onMouseLeave={function () {
            setSelectorOpen(false);
            setText('');
        }}>
        {selectedRating && selectedSymbol ? (<Fade in timeout={500}>
            <EmojiSelector>{renderEmoji(selectedRating)}</EmojiSelector>
          </Fade>) : (renderSelector())}
      </div>
    </Flex>);
};
